import { render, staticRenderFns } from "./AddProductKeywordGrid.vue?vue&type=template&id=18daad47"
import script from "./AddProductKeywordGrid.vue?vue&type=script&lang=js"
export * from "./AddProductKeywordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports